<template>
    <div class="bg-surface-background flex flex-col gap-4 h-full px-safe pb-safe">
        <div class="px-4 w-auto h-full mx-auto flex flex-col gap-4 relative items-center justify-center">
            <div class="flex flex-row gap-3 items-center">
                <Icon type="api" class="w-10"></Icon>
                <div class="text-2xl">Whoops</div>
            </div>
            <div class="text-center">
                <div v-if="errorType === 'notFound'">We couldn't find this page</div>
                <div v-else-if="errorType === 'token'">This seems like an invalid url</div>
                <template v-else>
                    <div>Something went wrong here.</div>
                    <div>Please tap label again.</div>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import { Icon } from '@tapp.online/ui'
    import { useRoute } from 'vue-router'

    const route = useRoute()
    const errorType = computed(() => route?.params?.type)
</script>
